<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="card card-box">
        <reminders-list-widget :default-filters="{categories: [1, 2, 3, 5, 6, 7]}"></reminders-list-widget>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="card card-box">
        <reminders-meetings-list></reminders-meetings-list>
      </div>
    </div>
  </div>
</template>

<script>
  import Customer from '@db2b/keystone/components/Entities/Customer.vue'
  import RemindersListWidget from '@db2b/keystone/components/Widgets/Reminders/RemindersListWidget'
  import RemindersMeetingsList from './Reminders/RemindersMeetingsList.vue'

  export default {
    name: 'reminders',
    components: {
      RemindersMeetingsList,
      RemindersListWidget
    },
    activated () {
      this.$store.commit('app/ui/changeTitle', 'Mes Rappels')
      this.$store.commit('app/ui/changeSubtitle', 'Liste des rappels associés à votre compte.')
    }
  }
</script>



// WEBPACK FOOTER //
// Reminders.vue?3566dd58